import { Head, Link } from "zudoku/components";
import { TopicCard } from "./components/TopicCard.js";
import { TopicCardGrid } from "./components/TopicCardGrid.js";

export function GettingStartedPage() {
  return (
    <article className="not-prose mx-auto w-full max-w-3xl pb-16">
      <Head>
        <title>Getting Started</title>
      </Head>

      <header className="mb-10 border-b border-border/60 pb-8">
        <h1 className="text-3xl font-semibold tracking-tight text-foreground sm:text-4xl mt-3">
          Getting Started
        </h1>
        <p className="mt-2 text-base text-muted-foreground">
          Integrate with the Alk API — authenticate, call endpoints, and ship document workflows.
        </p>
      </header>

      <p className="mb-10 text-[0.95rem] leading-7 text-muted-foreground">
        Alk gives you programmatic access to workflow operations: document ingestion, extraction
        orchestration, and structured result retrieval. Obtain an API key from your account team,
        then explore the guides below or jump straight into the{" "}
        <Link to="/api" className="font-medium text-primary underline-offset-4 hover:underline">
          interactive reference
        </Link>
        .
      </p>

      <TopicCardGrid>
        <TopicCard
          variant="journey"
          title="Integration Journey"
          description="Step-by-step path from API credentials to a production-ready integration."
          href="/integration-journey"
        />
        <TopicCard
          variant="workflow"
          title="Workflows"
          description="What a workflow is — columns, documents, collections, and extractions."
          href="/workflows"
        />
        <TopicCard
          variant="quickstart"
          title="Quickstart"
          description="Base URL, authentication headers, and your first workflow request in minutes."
          href="/introduction#quick-start"
        />
        <TopicCard
          variant="practices"
          title="Best Practices"
          description="Security, uploads, extractions, rate limits, and going live safely."
          href="/best-practices"
        />
        <TopicCard
          variant="basics"
          title="API Overview"
          description="Rate limits, use cases, and how the public API is organized under /api/v1."
          href="/introduction"
        />
        <TopicCard
          variant="reference"
          title="API Reference"
          description="Browse every endpoint, schema, and try requests in the interactive explorer."
          href="/api"
        />
      </TopicCardGrid>

      <section className="mt-12 rounded-xl border border-dashed border-border/70 bg-muted/30 px-5 py-4">
        <p className="text-sm text-muted-foreground">
          <span className="font-medium text-foreground">Base URL:</span>{" "}
          <code className="rounded-md bg-background px-1.5 py-0.5 text-[0.85rem]">
            https://api.alk.work/
          </code>
          <span className="mx-2 text-border">·</span>
          All public routes live under{" "}
          <code className="rounded-md bg-background px-1.5 py-0.5 text-[0.85rem]">/api/v1</code>
        </p>
      </section>
    </article>
  );
}
